import type { INavigator, IWindow } from 'oidc-client-ts';
import OidcSilentRenewWindow from './oidcSilentRenewWindow';

/**
 * An INavigator implementation that uses an Office.js Dialog for silent token renewal.
 */
export default class OidcSilentRenewNavigator implements INavigator {
  // eslint-disable-next-line class-methods-use-this
  public async prepare(): Promise<IWindow> {
    return new OidcSilentRenewWindow();
  }

  /**
   * The callback is not used in this navigator implementation.
   * The response is handled by the DialogMessageReceived event handler in OidcSilentRenewWindow.
   */
  // eslint-disable-next-line class-methods-use-this, no-empty-function
  public async callback(): Promise<void> {
    // This method is required by the INavigator interface but is intentionally empty.
  }
}
